<script>
export default {
  name: 'CrawlLimitProgressBar',
  props: {
    // Word count from the current knowledge base
    usedCrawl: {
      type: Number,
      required: true,
      default: 0
    },

    crawlLimit: {
      type: Number,
      required: true,
      default: 0
    },
  },  
  computed: {
    
    // Get the total word count for this knowledge base
    totalUsedCrawl() {
      return this.usedCrawl || 0;
    },
    
    // Calculate the percentage of the word limit that's been used
    usagePercentage() {
      if (!this.crawlLimit) return 0;
      return Math.min(100, Math.round((this.totalUsedCrawl / this.crawlLimit) * 100));
    },
    
    // Get class based on usage percentage
    progressClass() {
      if (this.usagePercentage >= 90) return 'bg-red-500';
      if (this.usagePercentage >= 75) return 'bg-yellow-500';
      return 'bg-green-500';
    },
    
    // Get text color based on usage percentage
    textClass() {
      if (this.usagePercentage >= 90) return 'text-red-600 dark:text-red-400';
      if (this.usagePercentage >= 75) return 'text-yellow-600 dark:text-yellow-400';
      return 'text-green-600 dark:text-green-400';
    },
    
    // Format large numbers with commas
    formattedUsedCrawl() {
      return this.totalUsedCrawl.toLocaleString();
    },
    
    // Format large numbers with commas
    formattedCrawlLimit() {
      return this.crawlLimit.toLocaleString();
    }
  }
}
</script>

<template>
  <div class="word-limit-progress-container bg-slate-50 dark:bg-slate-800/30 p-4 rounded-lg border border-slate-200 dark:border-slate-700">    
    <div class="flex flex-col sm:flex-row sm:items-center justify-between mb-2">
      <h3 class="text-sm font-medium text-slate-700 dark:text-slate-300 mb-1 sm:mb-0">
        {{ $t('KNOWLEDGE.CRAWLLIMITPROGRESSBAR.TITLE') }}
      </h3>
      <div class="text-sm" :class="textClass">
        <span class="font-medium">{{ formattedUsedCrawl }}</span> / {{ formattedCrawlLimit }} {{ $t('KNOWLEDGE.CRAWLLIMITPROGRESSBAR.CRAWLS') }}
        <span class="ml-1 text-xs">({{ usagePercentage }}%)</span>
      </div>
    </div>
    
    <div class="relative h-2 w-full bg-slate-200 dark:bg-slate-700 rounded overflow-hidden">
      <div 
        class="absolute top-0 left-0 h-full transition-all duration-500 ease-out rounded"
        :class="progressClass"
        :style="{ width: `${usagePercentage}%` }"
        role="progressbar" 
        :aria-valuenow="usagePercentage" 
        aria-valuemin="0" 
        aria-valuemax="100"
      ></div>
    </div>
      <p v-if="usagePercentage >= 90" class="mt-2 text-xs text-red-600 dark:text-red-400">
      <span class="font-medium">{{ $t('KNOWLEDGE.CRAWLLIMITPROGRESSBAR.WARNING_TITLE') }}:</span> {{ $t('KNOWLEDGE.CRAWLLIMITPROGRESSBAR.WARNING_MESSAGE') }}
    </p>
    <p v-else-if="usagePercentage >= 75" class="mt-2 text-xs text-yellow-600 dark:text-yellow-400">
      <span class="font-medium">{{ $t('KNOWLEDGE.CRAWLLIMITPROGRESSBAR.NOTE_TITLE') }}:</span> {{ $t('KNOWLEDGE.CRAWLLIMITPROGRESSBAR.NOTE_MESSAGE') }}
    </p>
    <p v-else class="mt-2 text-xs text-slate-500 dark:text-slate-400">
      {{ $t('KNOWLEDGE.CRAWLLIMITPROGRESSBAR.SUCCESS_MESSAGE') }}
    </p>
  </div>
</template>